<template>
  <Listbox v-model="selected">
    <div class="relative w-full drop-down">
      <ListboxButton
        class="w-full py-2 px-2 md:px-4 border border-brand-mid-gray shadow-sm rounded focus:border-brand-green focus:ring-brand-green max-w-50 bg-white"
        :class="{
          'bg-brand-light-gray': (showSelectedAsGray && !!(selected || initial)) || disabled
        }"
      >
        <div class="flex justify-between">
          <div class="flex text-left max-w-4/5">
            <span
              class="text-left text-sm md:text-base truncate overflow-ellipsis"
              :class="[
                showSelectedAsGray && !(selected || initial)
                  ? 'text-brand-mid-gray'
                  : 'text-brand-green'
              ]"
              >{{
                selected
                  ? `www.rentapplication.net/${selected.slug}`
                  : initial
                  ? `www.rentapplication.net/${initial.slug}`
                  : placeholder
              }}</span
            >
          </div>
          <div class="flex flex-row-reverse">
            <img src="@/assets/icons/chevron-down.svg" class="w-4 md:w-5" />
          </div>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-40 md:max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
        >
          <slot name="option">
            <ListboxOption
              v-slot="{ active }"
              v-for="item in getApplicationTemplates"
              :key="item.label"
              :value="item"
              as="template"
            >
              <li
                class="max-w-full px-2 cursor-pointer flex justify-between"
                :class="[
                  active ? 'text-white bg-brand-green' : 'text-brand-black',
                  'cursor-default select-none relative py-2 hover:bg-brand-green group'
                ]"
              >
                <p
                  class="text-sm md:text-base truncate overflow-ellipsis"
                  :class="[active ? 'text-white' : 'text-brand-green group-hover:text-white']"
                >
                  {{ `...net/${item.slug}` }}
                </p>
                <p
                  class="text-sm md:text-base truncate overflow-ellipsis"
                  :class="[active ? 'text-white' : 'group-hover:text-white']"
                >
                  <span
                    class="text-sm italic"
                    :class="[active ? 'text-white' : 'text-brand-mid-gray group-hover:text-white']"
                    >Last used:</span
                  >
                  {{ formatDate(item.created) }}
                </p>
              </li>
            </ListboxOption>
          </slot>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>
<script>
import moment from "moment"
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue"
import { mapGetters } from "vuex"
import { APPLICATION_TEMPLATE_GET_LIST } from "@/store/types"

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  props: {
    initial: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: "Select form for application"
    }
  },
  emits: ["select"],
  computed: {
    ...mapGetters(["getCurrentUser", "getApplicationTemplates"])
  },
  data() {
    return {
      selected: null,
      showSelectedAsGray: true,
      disabled: false
    }
  },
  watch: {
    selected(val) {
      this.$emit("select", val)
    }
  },
  async mounted() {
    if (!this.getApplicationTemplates) {
      await this.$store.dispatch(APPLICATION_TEMPLATE_GET_LIST, { page: 1 })
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MM/DD/YY")
    }
  }
}
</script>
